import React from "react";
import { AgreementPage } from "@/components";
import agreementsData from "@/assets/agreements/agreements.json";

/**
 * Terms page component that displays the terms of service and early preview agreement.
 */
export default function TermsScreen() {
  return (
    <AgreementPage
      title="Terms of Service & Early Preview Agreement"
      content={agreementsData.tos}
    />
  );
}
